<template>
  <div id="vendorsLoading" class="vs-con-loading__container">
    <vs-alert
      color="warning"
      active="true"
      class="mb-4"
      v-if = "pending != 0"
    >
    <feather-icon icon="AlertTriangleIcon" svgClasses="h-4 w-4" />
    <span> TIENES {{pending}} Documento(s) Pendiente(s)</span> 
    <a @click="$router.push('/repse/request').catch(() => {})" :style="{ cursor: 'pointer' }" > Subir </a>
    </vs-alert>

    <upload-file ref="uploadFille" :expenseId="expenseId" @success="init" />
    <vs-row>
      <vs-col>
        <card-list :data="statusList" @updateFilter="updateFilter" />
      </vs-col>
    </vs-row>
    <div>
      <vx-card :title="$t('expenses')">
        <template slot="actions">
          <vs-row>
            <vs-input
              icon="search"
              :placeholder="$t('search')"
              class="mx-2 mt-1"
              v-model="params.search"
              @keyup.enter="search()"
            />
            <vs-button
              class="mx-2 mt-1"
              color="success"
              type="filled"
              icon-pack="feather"
              icon="icon-file-text"
              @click="exportData()"
              >Export
            </vs-button>
            <upload-expense @success="init" />
          </vs-row>
        </template>
        <expense-table
          :data="expenses"
          @loadMore="loadMore"
          @uploadClick="openUpload"
        />
      </vx-card>
    </div>
  </div>
</template>

<script>
import CardList from './components/CardList.vue'
import ExpenseTable from './components/ExpenseTable.vue'
import UploadExpense from './components/UploadExpense.vue'
import UploadFile from './components/UploadFile.vue'
import defaultStatusList from './components/defaultStatusList.js'
import vendor from '@/http/requests/vendor/index.js'
import mixins from '@/mixins'
import { BASE_URL } from '@/urls.js'
export default {
  mixins: [mixins],
  components: {
    CardList,
    ExpenseTable,
    UploadExpense,
    UploadFile,
  },
  data() {
    return {
      statusList: [],
      expenses: [],
      lastPage: 1,
      params: {
        rfc: '',
        page: 1,
        status: '',
        search: '',
        sortBy: ['Expenses.ReceivedDate'],
        sort: ['DESC'],
      },
      loading: {
        data: false,
        cards: false,
      },
      expenseId: '',
      pending:0
    }
  },
  computed: {
    isLoading() {
      return this.loading.data || this.loading.cards
    },
  },
  methods: {
    updateFilter(e) {
      this.statusList.map((el) => {
        el.active = el.id === e ? true : false
      })
      this.params.status = e
      this.params.page = 1
      this.getData()
    },
    search() {
      this.params.page = 1
      this.getData()
    },
    getData() {
      let payload = { ...this.params }
      Object.keys(payload).forEach(
        (k) => (payload[k] === null || payload[k] === '') && delete payload[k]
      )
      this.loading.data = true
      vendor
        .getData(payload)
        .then((response) => {
          if (this.params.page === 1) {
            this.expenses = [...response.data.data]
          } else {
            this.expenses = [...this.expenses, ...response.data.data]
          }
          this.lastPage = response.data.last_page
          this.loading.data = false
        })
        .catch((response) => {
          this.$vs.notify({
            color: 'danger',
            title: 'Atención',
            text: 'Ha ocurrido un error',
          })
          this.loading.data = false
        })
    },
    getCardsData() {
      this.statusList = [...defaultStatusList]
      this.loading.cards = true
      vendor
        .getCardsData({ rfc: this.params.rfc })
        .then((response) => {
          this.statusList.map((el) => {
            let status = response.data.result.find((item) => item.id === el.id)
            if (status !== undefined) {
              el.color = status.color
              el.icon = status.icon
              el.total = status.total
            } else {
              if (el.id !== '') {
                el.color = '#E0E0E0'
                el.total = 0
              }
            }
          })
          this.statusList[0].total = response.data.total
          this.loading.cards = false
        })
        .catch((response) => {
          this.$vs.notify({
            color: 'danger',
            title: 'Atención',
            text: 'Ha ocurrido un error',
          })
          this.loading.cards = false
        })
    },
    loadMore() {
      if (this.params.page >= this.lastPage) {
        return
      }
      this.params.page++
      this.getData()
    },
    exportData() {
      let statusId =
        this.params.status === '' ? '0,1,2,4,6,7,13' : this.params.status
      let url =
        BASE_URL +
        '/internal_api/vendors-portal/export/8ew7t978EWRTDSXFG525w5937325WFDSfvd?rfc=' +
        this.params.rfc +
        '&status_id=' +
        statusId +
        '&search=' +
        this.params.search
      window.open(url)
    },
    init() {
      const storageVendor = localStorage.getItem('vendor')
      let vendor = JSON.parse(storageVendor)
      this.params.rfc = vendor.rfc
      this.getCardsData()
      this.getData()
      this.repseAlert()
    },
    openUpload(e) {
      this.expenseId = e
      this.$refs.uploadFille.open()
    },
    repseAlert(){
      const storageVendor = localStorage.getItem('vendor')
      let vendorActive = JSON.parse(storageVendor)
      let repseActive = vendorActive.repse_active

      if(repseActive == 1){
        
      vendor
        .getRepseAlert(this.params.rfc)
        .then((response) => {
          this.pending = response.data.pending
        })
        .catch((response) => {
          this.$vs.notify({
            color: 'danger',
            title: 'Atención',
            text: 'Ha ocurrido un error',
          })
        })
      }
    }
  },
  mounted() {
    this.init()
  },
  watch: {
    isLoading(val) {
      if (val) {
        this.$vs.loading()
      } else {
        this.$vs.loading.close()
      }
    },
  },
}
</script>

<style>
@media (max-width: 576px) {
  .wfull {
    width: 100%;
  }
}
</style>
